<template>
  <div>
    <h1>Ajouter une activité hors-clinique</h1>
    <form-hcacttitre ref="formHcatit" />
    <el-divider></el-divider>
    <div style="margin-top: 8px">
      <el-button type="primary" :disabled="isSaving" @click="onSubmit"
        >Enregistrer</el-button
      >
      <el-button @click="onCancel">Annuler</el-button>
    </div>
  </div>
</template>
<script>
import FormHcacttitre from "@/components/rh/ui/form/FormHcacttitre";
import { strNormalize } from "@/fonctions";

export default {
  components: { "form-hcacttitre": FormHcacttitre },

  data() {
    return {
      isSaving: false,
    };
  },
  props: {
    routes: Object,
  },
  created() {
    // reset le form
    this.$store.commit("hc/resetHcactivite", "");
  },
  computed: {
    hcactiviteCreateStatus() {
      // 1 = action en cours, 2 = succès, 3 = échec
      return this.$store.state.hc.hcactiviteCreateStatus;
    },
  },
  methods: {
    onSubmit() {
      this.$refs.formHcatit.$refs.FormHcacttitre.validate((valid) => {
        if (valid) {
          // récupère les données de la boîte de dialogue
          const bd = this.$store.state.hc.hcactivite;
          // enlever les espaces avant et après dans le nom de la nouvelle fac
          bd.hcactivite_descri = bd.hcactivite_descri.trim();

          // vérifie si la faculté est  déjà dans la bd
          const HctsInBD = this.$store.getters["hc/hcactivitesInBD"];
          // nom de l'activité en minuscule et sans espace et sans accents pour la comparaison
          const hctNormalize = strNormalize(bd.hcactivite_descri);

          if (HctsInBD.filter((m) => m[2] == hctNormalize).length > 0) {
            this.$alert(
              "Cette activité hors-clinique est déjà enregistrée dans la base de données !",
              "Attention",
              {
                confirmButtonText: "Fermer",
                dangerouslyUseHTMLString: true,
              }
            );
            return false;
          } else {
            //crée un nouveau enregistrement
            this.$store.dispatch("hc/createHcactivite", {
              id_hc_cat: bd.id_hc_cat,
              hcactivite_descri: bd.hcactivite_descri,
            });
          }
        } else {
          return false;
        }
      });
    },
    onCancel() {
      // retourne à la liste des facultés
      this.$router.push(this.routes.tolist);
    },
  },
  watch: {
    hcactiviteCreateStatus() {
      // gère les messages et la navigation après soumission du formulaire
      if (this.hcactiviteCreateStatus == 2) {
        // message succès
        this.$message({
          message: "L'activité hors-clinique a été ajoutée à la base de donnée",
          type: "success",
        });

        // va au formulaire d'édition du la thèse
        this.$router.push(this.routes.toedit);
      } else if (this.hcactiviteCreateStatus == 3) {
        this.isSaving = false;
        // message échec
        this.$message.error({ message: "Echec de l'enregistrement !" });
      } else if (this.hcactiviteCreateStatus == 1) {
        this.isSaving = true;
      } else if (this.hcactiviteCreateStatuss == 0) {
        this.isSaving = false;
      }
    },
  },
};
</script>
